import React, { useCallback } from 'react'
import Counter, { CounterChangeEventHandler } from 'LuxKit/Counter'
import noop from 'lib/function/noop'
import BodyText from 'LuxKit/Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Group from 'components/utils/Group'
import MerchandiseMaxQuantityMessage from 'components/Merchandise/MerchandiseMaxQuantityMessage'

interface Props {
  quantity: number
  inventory?: number | null
  onAddItem?: () => void
  onRemoveItem?: () => void
}

function MerchandiseCartReviewTileQuantitySelector(props: Props) {
  const {
    quantity,
    inventory,
    onAddItem = noop,
    onRemoveItem = noop,
  } = props

  const handleQuantityChange = useCallback<CounterChangeEventHandler>((value, _, event) => {
    event.preventDefault()
    if (value > quantity) {
      onAddItem()
    } else {
      onRemoveItem()
    }
  }, [quantity, onAddItem, onRemoveItem])

  if (!inventory) {
    return null
  }

  const isMaxQuantityReached = quantity >= inventory

  return <VerticalSpacer gap={4}>
    <Group
      direction="horizontal"
      gap={8}
      verticalAlign="center"
      horizontalAlign="start"
      fullWidth
    >
      <BodyText variant="small" weight="bold">Qty</BodyText>
      <Counter
        size="small"
        value={quantity}
        min={1}
        max={inventory}
        onChange={handleQuantityChange}
      />
    </Group>
    {isMaxQuantityReached && <MerchandiseMaxQuantityMessage align="start" />}
  </VerticalSpacer>
}

export default React.memo(MerchandiseCartReviewTileQuantitySelector)
